import { render } from "./PermissionsApproval.vue?vue&type=template&id=59557a85&scoped=true&ts=true"
import script from "./PermissionsApproval.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionsApproval.vue?vue&type=script&setup=true&lang=ts"

import "./PermissionsApproval.vue?vue&type=style&index=0&id=59557a85&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59557a85"],['__file',"src/components/scan/admin/PermissionsApproval.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59557a85"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59557a85', __exports__)) {
    console.log('reload')
    api.reload('59557a85', __exports__)
  }
  
  module.hot.accept("./PermissionsApproval.vue?vue&type=template&id=59557a85&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('59557a85', render)
  })

}


export default __exports__